// ============================================================================
// buildInfo.js — versión del bundle cargado, inyectada en build por
// scripts/gen-build-env.js (variables REACT_APP_*). En dev (npm start) no hay
// .env.production.local, así que caen los valores por defecto.
// ============================================================================
export const BUILD_INFO = {
  version: process.env.REACT_APP_BUILD_VERSION || '0.0.0',
  branch: process.env.REACT_APP_GIT_BRANCH || 'dev',
  sha: process.env.REACT_APP_GIT_SHA || 'local',
  buildTime: process.env.REACT_APP_BUILD_TIME || 'en desarrollo',
  env: process.env.NODE_ENV || 'development',
};

// Cadena corta para logs/depuración: "v1.0.0 · main@4f04bca · 2026-07-13T10:00:00Z"
export const BUILD_LABEL =
  `v${BUILD_INFO.version} · ${BUILD_INFO.branch}@${BUILD_INFO.sha} · ${BUILD_INFO.buildTime}`;
